import React from "react";
import { motion } from "framer-motion";
import { Users, Shield, UserCheck, Smartphone } from "lucide-react";

const EmployeeStats = ({ summary }) => {
  const stats = [
    {
      title: "إجمالي الموظفين",
      value: summary.total_employees,
      icon: Users,
      gradient: "from-blue-600 to-blue-700",
      bgGradient: "from-blue-900/20 to-blue-800/20",
      borderColor: "border-blue-500/30",
    },
    {
      title: "المديرين",
      value: summary.total_admins,
      icon: Shield,
      gradient: "from-purple-600 to-purple-700",
      bgGradient: "from-purple-900/20 to-purple-800/20",
      borderColor: "border-purple-500/30",
    },
    {
      title: "الموظفين النشطين",
      value: summary.active_employees,
      icon: UserCheck,
      gradient: "from-green-600 to-green-700",
      bgGradient: "from-green-900/20 to-green-800/20",
      borderColor: "border-green-500/30",
    },
    {
      title: "يستخدمون 2FA",
      value: summary.employees_with_2fa,
      icon: Smartphone,
      gradient: "from-orange-600 to-orange-700",
      bgGradient: "from-orange-900/20 to-orange-800/20",
      borderColor: "border-orange-500/30",
    },
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.1 }}
      className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8"
      dir="rtl"
    >
      {stats.map((stat, index) => (
        <motion.div
          key={stat.title}
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.1 + index * 0.1 }}
          className={`bg-gradient-to-br ${stat.bgGradient} backdrop-blur-sm rounded-xl p-6 border ${stat.borderColor} hover:shadow-lg transition-all duration-300`}
        >
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-slate-400 mb-1">
                {stat.title}
              </p>
              <p className="text-2xl font-bold text-white">
                {stat.value}
              </p>
            </div>
            <div className={`bg-gradient-to-r ${stat.gradient} p-3 rounded-xl shadow-lg`}>
              <stat.icon className="w-6 h-6 text-white" />
            </div>
          </div>
        </motion.div>
      ))}
    </motion.div>
  );
};

export default EmployeeStats;